import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { ContentService } from '../shared/content.service';
import { Content } from '../shared/content';
import { UtilsService } from '../shared/utils.service';
import { IntlService } from '../shared/intl.service';
import { MetaService } from '../shared/meta.service';
import { ConfigService } from '../shared/config.service';

@Component({
    template: require('./partials/content-page-edit.component.html'),
})
export class ContentPageEditComponent extends Content implements OnInit {

    public action: string = 'add';
    pageForm: FormGroup;

    constructor (public pageConfig: ConfigService, private pageIntlService: IntlService, private pageMetaService: MetaService, private utils: UtilsService, private formBuilder: FormBuilder, private router: Router, private pageService: ContentService, private pageRoute: ActivatedRoute) {
        super(pageConfig, pageIntlService, pageMetaService, pageService, pageRoute);
        this.setType('page');
    }

    onAddTag () {
        let tags = this.pageForm.controls['tags'] as FormArray;
        tags.push(this.formBuilder.control(null));
    }

    onRemoveTag(index: any){
        let tags = this.pageForm.controls['tags'] as FormArray;
        tags.removeAt(index);
    }

    keyupEditorHandlerFunction(fieldPath: string[], text: string){
        this.pageForm.get(fieldPath).patchValue(text);
        //console.log(text);
    }

    public deleteContent(type: string, id: string){ 
        this.pageService.deleteContent(type,id);
        this.router.navigate(['pages/reload'], {relativeTo: this.route.parent});
        setTimeout(() => {
            this.router.navigate(['pages'], {relativeTo: this.route.parent});
        }, 500);  
    }

    ngOnInit() {

        this.pageRoute.params.subscribe((params: Params) => {
            
            // add
            this.pageForm = this.formBuilder.group({
                title: this.formBuilder.group(this.getIntlInitObject()),
                content: this.formBuilder.group(this.getIntlInitObject()),
                summary: this.formBuilder.group(this.getIntlInitObject()),
                _id: [null,[]],
                active: [false,[]],
                url: [null,[]],
                date: [null,[]],
                update_date: [null,[]], 
                tags: this.formBuilder.array(['']),
                // image: this.formBuilder.group({
                //     main: [null,[]]
                // })
            });

            // update
            if(params['id']!=0) {
                this.action = 'update';
                this.pageService.getContent(this.type, {_id: params['id']}, true).then(response => {
                        this.content = response;
                        this.pageForm = this.formBuilder.group({
                            title: this.formBuilder.group(this.content.title),
                            content: this.formBuilder.group(this.content.content),
                            summary: this.formBuilder.group(this.content.summary),
                            _id: [this.content._id,[]],
                            active: [this.content.active,[]],
                            url: [this.content.url,[]],
                            date: [this.content.date,[]],
                            update_date: [this.content.update_date,[]],
                            tags: this.formBuilder.array(this.content.tags),
                            // image: this.formBuilder.group({
                            //     main:  this.formBuilder.control(this.content.image && this.content.image.main ? this.content.image.main : null)
                            // })
                        }); 
                    });
            }

        });

        this.pageRoute.parent.params.subscribe((params: Params) => {
            // Current language
            this.currentLanguage = params['lg'];
        });
        
    }

    onSubmit(){
        // update date
        this.pageForm.controls['update_date'].setValue(Date.now());
        // save
        this.pageService.saveContent('page', this.action, this.pageForm.value).then(res =>{
            // nav
            this.router.navigate(['pages'], {relativeTo: this.route.parent});
        })
    }

} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-page-edit.component.ts